import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "flowbite"

// Long-press (mobile) or chevron click (desktop) opens a Flowbite dropdown.
// Short tap still submits the parent form normally.
//
// Attach to the wrapper element containing both the form button and the chevron:
//
//   div data-controller="utilities--long-press"
//       data-utilities--long-press-dropdown-value="water-dropdown"
//
//     button data-utilities--long-press-target="press"
//            data-action="touchstart->utilities--long-press#touchstart ..."
//
//     button data-action="click->utilities--long-press#toggle"
export default class extends Controller {
  static values = { dropdown: String }
  static targets = ["press"]

  connect() {
    this._timer = null
    this._fired = false

    // Suppress iOS native long-press menu on the press target
    this.pressTarget.style.webkitTouchCallout = "none"
    this.pressTarget.style.webkitUserSelect = "none"
  }

  touchstart() {
    this._fired = false
    this._timer = setTimeout(() => {
      this._fired = true
      this._dropdown().show()
    }, 400)
  }

  touchend(event) {
    clearTimeout(this._timer)
    if (this._fired) {
      event.preventDefault()
      this._fired = false
    }
  }

  touchmove() {
    clearTimeout(this._timer)
  }

  toggle() {
    this._dropdown().toggle()
  }

  // --- private ---------------------------------------------------------------

  _dropdown() {
    return this.__dropdown ||= new Dropdown(
      document.getElementById(this.dropdownValue),
      this.element,
      { placement: "bottom-end", triggerType: "none" }
    )
  }
}
